import PaypalFeeCalculator from '@/tools/paypalFeeCalculator.vue';
import { mountVueTool } from './shared/mountVueTool';

mountVueTool(PaypalFeeCalculator, 'paypalFeeCalculator');
